//src/components/forIndependentSolutionsData
import ReceiveExpertGuidance from '../assets/Deliver_better_care.jpg';
import DigitalPresence from '../assets/manage_your_reputation.jpg';
import FasterPayments from '../assets/get_paid_faster.jpg';
import DecisionOnData from '../assets/get_deeper_insights.jpg';
import EngageNewPatient from '../assets/appoinment.png';
import TailorCare from '../assets/Website-visitors.png';

const forNewPracticesSolutionsData = [
    {
        id: 1,
        title: "Receive expert guidance and support",
        text: "Commencing a new practice can feel both exciting and overwhelming, but with Doclivo, you're not alone. Your dedicated onboarding manager will swiftly guide you through the process, offering best-in-class training and enrollment support. Whether you're collaborating with an existing team, forming a new one, or working independently, Doclivo provides the resources, time, and support necessary for your success.",
        image: ReceiveExpertGuidance,
        buttonLabel: "Learn more",
    },
    {
        id: 2,
        title: "Establish your Digital presence",
        text: "In a landscape where 90% of patients assess their doctors online before scheduling appointments, it's crucial to make a compelling first impression. Reach new patients and foster existing relationships with a responsive, SEO-optimized website, search marketing tools, automated reputation management, polished web profiles, and effective social media management.",
        image: DigitalPresence,
        buttonLabel: "Learn more",
    },
    {
        id: 3,
        title: "Engage with new patients",
        text: "Respond to the demand for convenience, as nearly 80% of patients express a willingness to change doctors for a more convenient experience. Empower your staff to deliver a patient-centered approach with online scheduling, appointment reminders, digital patient intake forms, text messaging, and a secure patient portal.",
        image: EngageNewPatient,
        buttonLabel: "Learn more",
    },
    {
        id: 4,
        title: "Tailor care to your way",
        text: "Enhance clinical efficiency throughout the patient journey with Doclivo, a certified, cloud-based EHR crafted by healthcare providers. Seamlessly integrated with the Doclivo platform, it is driven by intelligent automation and real-time patient insights. Doclivo's care delivery solutions encompass provider scheduling, clinical notes, flowsheets, eRx, eLabs, telehealth, and a secure mobile application, enabling the delivery of modern care from any location.",
        image: TailorCare,
        buttonLabel: "Learn more",
    },
    {
        id: 5,
        title: "Facilitate Faster Payments",
        text: "Addressing industry challenges, where nearly 50% of providers struggle to collect patient balances within 30 days and 71% of consumers find medical bills confusing. Unlock profitability and efficiency in revenue cycle management with our billing and payment solution. This comprehensive approach includes intuitive practice management, intelligent process automation, and modern patient payment solutions.",
        image: FasterPayments,
        buttonLabel: "Learn more",
    },
    {
        id: 6,
        title: "Base Your Decisions on Data",
        text: "As a new business, leveraging Doclivo data and insights allows you to analyze operating costs and make informed business decisions, fostering the growth of your practice and revenue.",
        image: DecisionOnData,
        buttonLabel: "Learn more",
    },


    // Add more items as needed

];

export default forNewPracticesSolutionsData;